import React, { useState, useEffect } from "react";
import Dashboard from "../Dashboard/Dashboard";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import addemp from "../../Assets/Add Employee.svg";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import check from "../../Assets/Frame 1191.svg";
import edit from "../../Assets/edit.svg";
import del from "../../Assets/Box.svg";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import AddEmployee from "./AddEmployee/AddEmployee";
import io from 'socket.io-client';


const socket = io('https://policydekhoo-backend.onrender.com');

const Employee = () => {
  const navigate = useNavigate();

  // const [data, setData] = useState('Initial Data');

  useEffect(() => {
 
      socket.on('dataUpdated1', (updatedData) => {
          setemployees_data(updatedData);
      });
      socket.on('addData1', (Data) => {
          setemployees_data(Data);
      });
      
      socket.on('deleteData1', (Data) => {
          setemployees_data(Data);
      });
      return () => {
          socket.disconnect();
      };
  }, []);



  const dataAdd=(dataSet)=>{
    let data=[...employees_data]
    let lid=data[(data.length)-1].id
    let id =lid.split("id")
    let nid=parseInt(id[1])+1
    dataSet.id=`Pid${nid}`
    console.log(dataSet,"\\\\\\\\\\\\\\\\\\\\");
    data.push(dataSet)
    setemployees_data(data)
    socket.emit('addData', data);
  }

  const dataUpdate=(dataSet,id)=>{
    console.log(dataSet,id,"[][][][][]")
    const temp=[...employees_data]
          let ind=""
          temp.map((val,index)=>{
            if(val.id===id)
              {
                ind=index
              }
          })
          const temp1={...dataSet}
          temp1.id=id;
          temp[ind]=(temp1);
          setemployees_data(temp)
          socket.emit('editData', temp);
          
          console.log(temp1,"[][][][][][[[[")    
           
  }



  // const top100Films = [
  //   { label: "The Shawshank Redemption", year: 1994 },
  //   { label: "The Godfather", year: 1972 },
  //   { label: "The Godfather: Part II", year: 1974 },
  //   { label: "The Dark Knight", year: 2008 },
  //   { label: "12 Angry Men", year: 1957 },
  //   { label: "Schindler's List", year: 1993 },
  //   { label: "Pulp Fiction", year: 1994 },
   
  // ];
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#FFFFFF",
    border: 0,
    borderRadius: "0.5cm",
    boxShadow: 0,
  };
  const [open, setOpen] = useState(false);
  const [what, setwhat] = useState("");
  const [rowdata, setrowdata] = useState([]);
  const handleOpen = (val1, row) => {
    setwhat(val1);
    setrowdata(row);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  const columns = [
    { id: "Employee id", label: "Employee id", minWidth: 170 },
    { id: "Employee name", label: "Employee name", minWidth: 170 },
    { id: "Contact", label: "Contact", minWidth: 170 },
    {
      id: "Email",
      label: "Email",
      minWidth: 170,
      align: "left",
      format: (value) => value.toLocaleString("en-US"),
    },
    {
      id: "Username",
      label: "Username",
      minWidth: 170,
      align: "left",
      format: (value) => value.toLocaleString("en-US"),
    },
    {
      id: "Password",
      label: "Password",
      minWidth: 170,
      align: "left",
      format: (value) => value.toFixed(2),
    },
  ];
  //   const rows = [
  //     ["Aman Gahlot", "96356363633", "aman@12.com", "AMAN_.12", "xxxxxx"],
  //     ["Jai Raj Chouhan  ", "96356363633", "jai@12.com", "JAI_.12", "xxxxxx"],
  //     ["Rohin Singh Rawat", "96356363633", "rohan@12.com", "ROHAN_.12", "xxxxxx"],
  //     ["Employee4", "96356363633", "emp4@12.com", "EMP4_.12", "xxxxxx"],
  //     ["Employee5", "96356363633", "emp5@12.com", "EMP5_.12", "xxxxxx"],
  //     ["Aman Gahlot", "96356363633", "aman@12.com", "AMAN_.12", "xxxxxx"],
  //     ["Aman Gahlot", "96356363633", "aman@12.com", "AMAN_.12", "xxxxxx"],
  //     ["Jai Raj Chouhan  ", "96356363633", "jai@12.com", "JAI_.12", "xxxxxx"],
  //     ["Rohin Singh Rawat", "96356363633", "rohan@12.com", "ROHAN_.12", "xxxxxx"],
  //     ["Employee4", "96356363633", "emp4@12.com", "EMP4_.12", "xxxxxx"],
  //     ["Employee5", "96356363633", "emp5@12.com", "EMP5_.12", "xxxxxx"],
  //     ["Aman Gahlot", "96356363633", "aman@12.com", "AMAN_.12", "xxxxxx"],
  //   ];

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const [employees_data, setemployees_data] = useState([
  ]);

  const [tableName, settablename] = useState("employees_data");

  useEffect(() => {
    const getemployees_data = async () => {
      const url = `https://policydekhoo-backend.onrender.com/GetAllData?tableName=${tableName}`;

      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }).then((response => response.json()))
        if(response.msg!=="Error Fetching  data")
          {
            setemployees_data(response);
            
          }
         
      } catch (error) {
        console.error("Error fetching groups:", error);
      }
    };

    getemployees_data();
  }, []);

  const rows = employees_data.map((data) => [
    data.id,
    data.Employee_Name,
    data.Contact_Number,
    data.Email_Address,
    data.User_Name,
    data.Pass_word,
    data.Roles
  ]);

  const [idselected, setidselected] = useState();

  const handleDelete = async (id) => {
    try {
      // console.log("Id to be deleted is:", id);

      // Construct the URL with the tableName and id
      const url = `https://policydekhoo-backend.onrender.com/Removeempdata?tableName=${tableName}&id=${id}`;

      // Make a DELETE request to the URL
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });

      // Check if the request was successful
      if (!response.ok) {
        throw new Error("Failed to delete data");
      }

      // Optionally, you can handle the response here
      const responseData = await response.json();
      const temp=[...employees_data]
      let ind=""
      temp.map((val,index)=>{
        if(val.id===id){
          ind=index;
          console.log(val,index)
        }
      })
      temp.splice(ind,1);
      console.log(temp,"jaiiii");
      console.log("Delete response:", responseData);
      setemployees_data(temp)
      socket.emit('deleteData', temp);


      // Refresh the data after deletion
      // Call the function that fetches data again
      // getCarInsurancedata();
    } catch (error) {
      console.error("Error deleting data:", error);
    }
  };
  const role=JSON.parse(localStorage.getItem("userData")).Roles; 
  
  return (
    <>
      <Dashboard name={"employee"} heading={"Employee List"} />

      <div className={role=="Admin"?'main-div':"main-div2"}>
        <div className="row m-2 align-items-center mt-5">
          {/* <div className="col-10 my-sm-1 my-2 col-sm-4 col-md-3">
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              // options={top100Films}
              // sx={{ width: 280 }}
              renderInput={(params) => <TextField {...params} label="Search" />}
            />
          </div> */}
          <div className="col  my-sm-1 my-2 align-items-center">
            <button className="btn fs-5 btn-secondary"onClick={() => {
                handleOpen("Add");
              }}>
            <img
              src={addemp}
              alt="add"
              className="me-2"
              
              style={{ width: "30px" ,color:"white"}}
            />
            Add Employees
            </button>
          </div>
        </div>
        <div className="row m-2">
          <Paper sx={{ overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: "70vh" }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        <b> {column.label}</b>
                      </TableCell>
                    ))}
                    <TableCell style={{ minWidth: 200 }}>
                      <b>Status</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.code}
                        >
                          {row.map((val, index) => {
                            
                            return index<6?<TableCell align="left">{val}</TableCell>:"";
                          })}
                          <TableCell align="left">
                            {" "}
                            <label className="me-1">
                              <img
                                src={check}
                                onClick={() => {
                                  navigate(
                                    `/Employee/RightsAndPermissions/${row[0]}`
                                  );
                                }}
                                alt=""
                              />
                            </label>
                            <label className="me-1">
                              <img
                                src={edit}
                                alt=""
                                onClick={() => {
                                  handleOpen("Edit", row);
                                }}
                              />
                            </label>
                            <label className="me-1">
                              <img
                                src={del}
                                alt=""
                                onClick={() => handleDelete(row[0])}
                              />
                            </label>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </div>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <AddEmployee handleClose={handleClose} what={what} row={rowdata} dataAdd={dataAdd} dataUpdate={dataUpdate} />
        </Box>
      </Modal>
    </>
  );
};

export default Employee;
